import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as HELPER from '@src/config/helper';
import { ROLE_FEATURES, REGEX_EMAIL_VALIDATION, SOURCE_WEB, ENCRYPTED_AGENCY_FIELDS, AGENCY_STATUS, AGENCY_DOC_STATUS, AGENCY_SOURCE, ACTIVE_INACTIVE_AGENCY, MAX_FILE_UPLOAD, STATUS_FIELD, STATUS_SUCCESS, PAGE_NUMBER } from '@src/config/constant';

import ReactSelect from '@common/ReactSelect';
import { addAgency, addAgencyDocument, deleteAgencyDocument, getAgencyDetailData, approveAgency } from '@src/store/slices/agency';
import { getAgencyUsers,mapSalesAgent } from '@src/store/slices/insurance';
import { bankList, getMasterConfig } from '@src/store/slices/common';
import { useDispatch, useSelector } from 'react-redux';
import InputField from "../../../common/InputField";
import { getPartnerMappingList } from '@src/store/slices/partner';
import DocResubmitModal from './DocResubmitModal';
import ImageSlider from './ImageSlider';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import ConfirmPopUp from '@src/common/ConfirmPopUp';
import FullPageLoader from '@src/common/FullPageLoader';
import { Tab, Nav } from 'react-bootstrap';
import { approveAgencyDocument, updateAgencyStatus, getSalesOfficerList} from '@src/store/slices/agency';
import AgencyCommentModal from './AgencyCommentModal';
import AgencyPartnerMapping from './agencyPatnerMapping';
import AgencyUserListTable from './agencyUser/AgencyUserListTable';
import { AgencyAgentOption } from '../../../store/types/Common';
import MultiSelect from '../../../common/MultiSelect';


export default function AddEditInsuranceAgency(props: any): ReturnType<React.FC> {

    let [agencyBanksLists, setAgencyBanksList] = useState<any>([]);
    const [soList, setSOList] = useState<Array<any>>([]);
    const [vatPayOut, setVatPayOut] = useState<Array<any>>([]);
    
    const [creditTerm, setCreditTerm] = useState<Array<any>>([]);
    // const [vehicleTypeCount , setVehicleTypeCount] = useState(0);
    const [partnerMappingCount, setPartnerMappingCount] = useState(0);
    const isDisabled = false;
    let initialInputState = {
        agency_name: '',
        email: '',
        mobile: '',
        tin_id_no: '',
        bank_name: '',
        branch_name: '',
        account_no: '',
        account_name: '',
        images: [],
        partner_id: [],
        source: '',
        doc_status: '',
        agent_id: '',
        credit_terms: '',
        vat_pay_out: 0
    };

    let [selectedInput, setSelectedInput] = useState<any>(initialInputState)
    let [errors, setErrors] = useState<any>({})
    let [previewImages, setPreviewImages] = useState<any>([]);
    // let [insuranceCompanies, setInsuranceCompanies] = useState<string[]>([]);
    let [resubmitDocPopup, setResubmitDocPopup] = useState(false);
    let [imageSlider, setImageSlider] = useState(false);
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();
    const [trigger, setTrigger] = useState(0);
    const [basicDetailsName, setBasicDetailsName] = useState('Agency')
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    let [loading, setLoading] = useState<boolean>(false)
    const [disableField, setDisableField] = useState(false);
    const [activeImageIndex, setActiveImageIndex] = useState(-1);
    const [actionType, setActionType] = useState<any>('');
    const [pendingAction, setPendingAction] = useState<any>(null);
    const [handleType, setHandleType] = useState('');
    const [viewTimeLine, setViewTimeLine] = useState(false);
    const [activeTab, setActiveTab] = useState('first');
    const [agencyType, setAgencyType] = useState<any>(null); 

    const [editForm, setEditForm] = useState(true);
    const navigate = useNavigate();
    const queryParams = useParams();

    const dispatch: any = useDispatch();
    const commonState = useSelector((state: any) => state.common);
    const agency_id = queryParams.id//agency_id;
    let [triggerAgencyList, setTriggerAgencyList] = useState(0);

    // Variable to define agency_agent_data
    const [agencyAgentData, setAgencyAgentData] = useState<AgencyAgentOption[]>([]);
    const [mappedSalesOfficer, setMappedSalesOfficer] = useState<Array<any>>([]);
    const [salesAgentOfficerName, setSalesAgentOfficerName] = useState<Array<any>>([]);

    // Initial default tab
    const [defaultTab, setDefaultTab] = useState<string>('tab-0');

    /**
     * function to handle change in input field values
     * @param name 
     * @param value 
     */
    const handleChange = (name: string, value: any) => {
        setSelectedInput((prev: any) => ({
            ...prev,
            [name]: value.value
        }));

        setErrors((prevErrors: any) => ({
            ...prevErrors,
            [`${name}`]: ''
        }));

        errors[name] = '';
        setErrors({ ...errors });
    }

    const getAllAgencyUsers = async () => {
        setLoading(true)
        const users: any = await getAgencyUsers()
        if (users?.data?.length) {
            setSOList(users.data)
        }
        setLoading(false)
    }

    const getAllMapAgencyUsers = async () => {
        setLoading(true)
        const users: any = await mapSalesAgent()
        if (users?.data?.length) {
            setMappedSalesOfficer(users.data)
        }
        setLoading(false)
    }

    const updatePartnerCount = (count: number) => {
        setPartnerMappingCount(count);
    };

    useEffect(() => {
        const getMasterConfigData = async () => {
            let agencyData: AgencyAgentOption[] = [];
            if (Object.keys(commonState.common).length === 0) {
                const response: any = await dispatch(getMasterConfig());
                setCreditTerm(response?.data?.agency_credit_terms);
                // setVehicleTypeCount(response?.data?.vehicle_type.length)
                agencyData = response?.data?.agency_agent_data;
                setVatPayOut(response?.data?.vat_pay_out)
                setAgencyAgentData(agencyData)
            } else {
                setCreditTerm(commonState.common.agency_credit_terms);
                // setVehicleTypeCount(commonState.common.vehicle_type.length)
                agencyData = commonState.common.agency_agent_data;
                setAgencyAgentData(agencyData)
                setVatPayOut(commonState?.common?.vat_pay_out);
            }
            const selectedIndex = agencyData?.findIndex(item => item.label === basicDetailsName)
            setDefaultTab(`tab-${selectedIndex !== -1 ? selectedIndex : 0}`);
        }
        getMasterConfigData();
        // eslint-disable-next-line
    }, [dispatch, commonState]);
    

    const handleInputChange = (name: string, event: any) => {
        const value = event.target.type === "checkbox"  ? (event.target.checked ? 1 : 0)  : event.target.value;

        setSelectedInput((prev: any) => ({
            ...prev,
            [name]: value
        }));

        setErrors((prevErrors: any) => ({
            ...prevErrors,
            [`${name}`]: ''
        }));

        errors[name] = '';
        setErrors({ ...errors });
    }

    // Method to handle the value change for ReactSelect
    const handleSelectChange = (name: string, selectedOption: any,isMulti: boolean = false) => {
         const value = isMulti
        ? (selectedOption ? selectedOption.map((opt: any) => opt.value) : []) // MultiSelect case
        : (selectedOption ? selectedOption.value : ''); // Single Select case

        
        // Extract the value from the selectedOption
       // const value = selectedOption ? selectedOption.value : '';

        // Update the state with the selected value
        setSelectedInput((prev: any) => ({
            ...prev,
            [name]: value, // Set the selected value for the specific field
        }));

        // Reset the error state for this field
        setErrors((prevErrors: any) => ({
            ...prevErrors,
            [`${name}`]: '', // Reset error for this field
        }));

        // Update errors object
        const updatedErrors = { ...errors };
        updatedErrors[name] = '';
        setErrors(updatedErrors);
    };


    /**
     * function to submit api request
     */
    const handleSubmit = async () => {
        try {
            let errorExists = checkValidation()
            if (!errorExists) {
                // if (selectedInput?.partner_id.length === 0) {
                //     toast.error('Please select insurance partner.')
                //     return;
                // }
                setLoading(true);
                const agentType = agencyAgentData.find(item => item.label === basicDetailsName);
                let params: any = {}
                params.agency_name = selectedInput?.agency_name
                params.agent_id = selectedInput?.agent_id
                params.credit_terms = selectedInput?.credit_terms
                params.email = selectedInput?.email
                params.mobile = selectedInput?.mobile
                params.tin_id_no = selectedInput?.tin_id_no
                params.bank_name = +selectedInput?.bank_name
                params.branch_name = selectedInput?.branch_name
                params.account_no = selectedInput?.account_no
                params.account_name = selectedInput?.account_name
                // params.partner_id = selectedInput?.partner_id
                params.source = SOURCE_WEB
                params.type = agentType?.value || selectedInput?.type
                params.is_doc_required = selectedInput?.is_doc_required || 0
                params.vat_pay_out = selectedInput?.vat_pay_out || 0
                //for edit case agency_id will append
                if (agency_id) {
                    params.agency_id = agency_id
                }


                const documentFormData = new FormData();
                for (const key in selectedInput) {
                    let value = selectedInput[key];
                    if (key === 'images' && value?.length) {
                        value.forEach((file: File) => {
                            documentFormData.append('images', file);
                        });
                    }
                }

                const fields = ENCRYPTED_AGENCY_FIELDS;
                fields.forEach((field:any) => {
                    if (params?.[field]) {
                        params[field] = HELPER.EncodetoBase64(params[field]);
                    }
                });

                // add maping value into params
                if(selectedInput?.map_sales_agent_officer){
                    params.map_sales_agent_officer = selectedInput?.map_sales_agent_officer
                }
                //return;
                const res: any = await addAgency(params);
                if (res && res.status === STATUS_SUCCESS) {
                    toast.success(res.message)
                    setTriggerAgencyList(prev => prev + 1);
                    if (selectedInput?.images?.length > 0) {
                        documentFormData.append('agency_id', res.data.hashId);
                        documentFormData.append('source', "" + AGENCY_SOURCE['web']);
                        addAgencyDocument(documentFormData).then((res: any) => {
                            if (res && res.status === STATUS_SUCCESS) {
                                setTrigger(trigger + 1);
                            }
                        }).catch(err => setLoading(false))
                    } else {
                        //REFRESH PAGE
                        if (agency_id) {
                            setTrigger(trigger + 1);
                        }
                    }
                    //NAVIGATE TO EDIT PAGE AFTER CREATE
                    if (!agency_id) {
                        navigate('/agency/edit/' + res.data.hashId);
                    }
                    resetInputFields();
                    setEditForm(!editForm)
                } else {
                    setLoading(false);
                }

            }
        } catch (err) {
            setLoading(false)
        }
    }


    const handleFileInputChange = async (e: any) => {
        let selectedFiles = e.target.files;
        let validFiles: File[] = [];
        let imagePreview: any = [];
        let totalLength = selectedFiles.length + (previewImages?.length || 0)

        if (totalLength > MAX_FILE_UPLOAD) {
            toast.error("Maximum 5 Documents are allowed")
            return;
        }

        for (const file of selectedFiles) {
            let allowedExtensions = ['data:application/pdf']
            let base64PreviewImg: any = await HELPER.toBase64(file);
            let filetype = await HELPER.detectMimeType(base64PreviewImg, { allowedExtensions });
            let fileSize = file.size;

            if (!filetype) {
                toast.error("Please Select a valid file");
            } else if (fileSize < 25000 || fileSize > 5000000) {
                toast.error('file size should be between 25kb to 5mb');
            } else {
                validFiles.push(file);
                //previewImages.push(base64PreviewImg);
                imagePreview.push({ url: base64PreviewImg, type: file.type.split('/')[1] });
            }
        }

        if (validFiles.length > 0) {
            setSelectedInput((prev: any) => ({
                ...prev,
                images: [...(prev.images || []), ...validFiles]
            }));
            setPreviewImages((prev: any) => [...prev, ...imagePreview]);
        }

        e.target.value = null;

        errors['images'] = ''
        setErrors(errors)

    }

    const checkValidation = (): boolean => {
        let error = false
        setErrors({})
        // Regex for email validation
        if (!selectedInput.agency_name || selectedInput.agency_name === '') {
            errors['agency_name'] = 'agent name is required';
            error = true;
        }
        if (!selectedInput.account_no || selectedInput.account_no === '') {
            errors['account_no'] = 'account number is required';
            error = true;
        }
        if (!selectedInput.bank_name || selectedInput.bank_name === '') {
            errors['bank_name'] = 'bank name is required';
            error = true;
        }
        if (!selectedInput.email || selectedInput.email === '') {
            errors['email'] = 'email is required';
            error = true;
        } else if (!REGEX_EMAIL_VALIDATION.test(selectedInput.email)) {
            errors['email'] = 'Please enter a valid email';
            error = true;
        }

        if (!selectedInput.mobile || selectedInput.mobile === '') {
            errors['mobile'] = 'mobile number is required';
            error = true;
        } else if (selectedInput.mobile[0] !== '9' || selectedInput.mobile.length !== 10) {
            errors['mobile'] = 'No. should start from 9 and be 10 digits long';
            error = true;
        }

        if (!selectedInput.tin_id_no || selectedInput.tin_id_no === '') {
            errors['tin_id_no'] = 'tin id no is required';
            error = true;
        }
        if (!selectedInput.account_name || selectedInput.account_name === '') {
            errors['account_name'] = 'Account name is required';
            error = true;
        }
        if (!selectedInput?.images?.length && !selectedInput?.documents?.length) {
            errors['images'] = 'document is required'
            error = true;
        }
        if (!selectedInput.agent_id || selectedInput.agent_id === '') {
            errors['agent_id'] = 'sales officer is required';
            error = true;
        }
        // if (!selectedInput.credit_terms || selectedInput.credit_terms === '') {
        //     errors['credit_terms'] = 'credit term is required';
        //     error = true;
        // }
        if (!selectedInput.map_sales_agent_officer || selectedInput.map_sales_agent_officer.length === 0 || selectedInput?.map_sales_agent_officer[0] === 0) {
            errors['map_sales_agent_officer'] = 'Mapped Sales Agent Officer is required';
            error = true;
        }
        setErrors({ ...errors });
        return error
    }

    const resetInputFields = () => {
        setSelectedInput(initialInputState);
        setPreviewImages([]);
    }


    useEffect(() => {
        getAllAgencyUsers()
        getSalesOfficerName()
        getAllMapAgencyUsers()
        if (!commonState?.partner_list?.length) {

            let filters = {
                page_number: PAGE_NUMBER,
                pagination: false,
                namesOnly: true,
                status: STATUS_FIELD.ACTIVE,
                application_type_id: 4
            };
            if (!agency_id) setLoading(true);
            dispatch(getPartnerMappingList(filters)).then((res: any) => {
                if (!agency_id) setLoading(false);

                if (res && res.status === STATUS_SUCCESS) {
                    // const partnerMappingList = (res && res.data) || [];
                    // setInsuranceCompanies(partnerMappingList);
                }
            }).catch((err: Error) => {
                if (!agency_id) setLoading(false);

                console.error(err);
            });
        } else {
            // setInsuranceCompanies(commonState?.partner_list);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!commonState?.agencyBankList?.length) {
            dispatch(bankList()).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    setAgencyBanksList((prev: any) => [...prev, ...res.data]);
                }
            })
        } else {
            setAgencyBanksList(commonState?.agencyBankList);
        }
        // eslint-disable-next-line
    }, []);

    const handleResubmitDoc = (param: any) => {
        setHandleType(param)
        setResubmitDocPopup(!resubmitDocPopup)
    }

    const showImagePopup = (activeImg: number) => {
        setImageSlider(!imageSlider)
        setActiveImageIndex(activeImg)
    }

    useEffect(() => {
        // Check if 'agency_id' parameters are present
        if (agency_id) {
            setLoading(true);
            setEditForm(false)
            dispatch(getAgencyDetailData({ agency_id: agency_id, source: SOURCE_WEB })).then((res: any) => {
                setLoading(false)
                if (res && res.status === STATUS_SUCCESS) {
                    setDisableField(true);
                    const agencyData = res.data;
                    const documentPaths = agencyData?.document_data?.map((document: any) => ({ url: document.doc_path, id: document.id, status: document.status, type: (document.doc_path.indexOf('.pdf') !== -1 ? "pdf" : "image") }));
                    // Determine the value based on 'type'
                    // setBasicDetailsName(agencyAgentData.find(item => +item.value === +res.data.type)?.label || '');
                    setAgencyType(res?.data?.type);
                    setPartnerMappingCount(agencyData?.partner_mapping.length);
                    setSelectedInput({
                        agency_name: agencyData.name,
                        agent_id: agencyData.agent_id,
                        email: agencyData.email,
                        mobile: agencyData.mobile,
                        tin_id_no: agencyData.tin_id_no,
                        bank_name: agencyData.bank_name,
                        branch_name: agencyData.branch_name,
                        account_no: agencyData.account_no,
                        account_name: agencyData.account_name,
                        source: agencyData.source,
                        doc_status: agencyData.doc_status,
                        documents: agencyData.document_data,
                        status: agencyData.status,
                        id: agencyData.id,
                        type: agencyData.type,
                        partnerMapping: agencyData?.partner_mapping,
                        credit_terms: agencyData.credit_terms,
                        is_doc_required:+agencyData?.is_doc_required || 0,
                        vat_pay_out: agencyData.vat_pay_out || 0,
                        map_sales_agent_officer:agencyData.map_sales_agent_officer
                    });
                    setPreviewImages(documentPaths);


                    setEditForm(false)
                } else if (res?.message === "no_data_found") {
                    navigate("/not-found")
                }

            }).catch((err: Error) => {
                setLoading(false)
            })
        }
        // eslint-disable-next-line
    }, [searchParams, trigger]);

    // delete image function
    const handleImageDelete = async (image: any) => {
        if (!image || !Object.keys(image).length) return;


        setShowConfirmation(true);
        setActionType('deleteImage');
        setPendingAction({ image });
        setConfirmationMessage(`Are you sure you want to delete this document ?`);

    }

    const handleEdit = () => {
        setDisableField(!disableField);
        setEditForm(!editForm)
    }


    const addDataFor = (data: any) => {
        setErrors({})
        setBasicDetailsName(data);
    }

    const agencyProcess = (type: any) => {
        setShowConfirmation(true);
        setActionType(type);
        setConfirmationMessage(`Are you sure you want to ${type} ${selectedInput.agency_name} agency ?`);
    }

    const confirmYes = async () => {
        setShowConfirmation(false);

        if (actionType === 'approve' || actionType === 'reject') {
            approveAgency({ agency_id: agency_id, type: actionType }).then((res: any) => {
                if (res.status === STATUS_SUCCESS) {
                    toast.success(res.message)
                    setTrigger(trigger + 1);
                }
            });

        } else if (actionType === 'deleteImage') {
            const { image }: any = pendingAction;
            const agencyId = agency_id;
            let uploadedImages = (selectedInput?.documents?.length || 0);
            if (!agencyId || (!image?.type || image?.type === "new")) {
                // Just remove image from frontend for new entries
                //FIND INDEX TO REMOVE FROM UPLOADED IMAGES ARRAY
                let fileIndex = image.id - uploadedImages;

                // Just remove image from frontend for new entries
                setPreviewImages((prev: any) => prev.filter((img: any, idx: number) => idx !== image.id));
                setSelectedInput((prev: any) => ({
                    ...prev,
                    images: prev.images.filter((img: any, idx: number) => idx !== fileIndex)
                }));

                return;
            } else {
                // Call API to delete the document
                try {
                    let result: any = await deleteAgencyDocument({ agency_id: agencyId, id: image.id });

                    if (result.status === STATUS_SUCCESS) {
                        // Remove image from frontend
                        setPreviewImages((prev: any) => prev.filter((img: any) => img.id !== image.id));
                        setSelectedInput((prev: any) => ({
                            ...prev,
                            images: prev?.images?.filter((img: any) => img.id !== image.id),
                            documents: prev?.documents?.filter((img: any) => img.id !== image.id)
                        }));
                        toast.success('Image deleted successfully');
                    } else {
                        toast.error('Failed to delete image');
                    }
                } catch (error) {
                    toast.error('Failed to delete image');
                }
            }

        }
        else if (actionType === 'markAsVerified') {
            approveAgencyDocument({ agency_id, type: 'approve', source: 2 }).then((res: any) => {
                if (res.status === STATUS_SUCCESS) {
                    toast.success(res.message);
                    setTrigger(trigger + 1);

                }
            })
        } else if (["inactive", "active"].includes(actionType)) {

            if (+selectedInput.doc_status === AGENCY_DOC_STATUS['rejected'] && ["active"].includes(actionType)) {
                toast.error("Please approve documents first");
                return false;
            }

            let updatedStatus = selectedInput.status ? 0 : 1
            const updatedData: any = { id: selectedInput.id, status: updatedStatus };
            setLoading(true);

            dispatch(updateAgencyStatus(updatedData)).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    toast.success(res.message);
                    setSelectedInput((prev: any) => ({ ...prev, status: updatedStatus }))
                    setTriggerAgencyList(prev => prev + 1);
                }
                setLoading(false);
            }).catch((err: Error) => {
                setLoading(false);
            });
        }

        setActionType(null);
        setPendingAction(null);
    }



    const confirmNo = () => {
        setShowConfirmation(false);
        setActionType(null);
        setPendingAction(null);
    }

    const checkAgencyApprovedOrNot = (params: any) => {
        if(isDisabled){
            toast.error('Please create insurance partner mapping for all vehicle types');
            return;
        }
        if (selectedInput.doc_status !== 1) {
            toast.error('Please approve document first')
            return;
        }

        if (partnerMappingCount < 1) {

            toast.error('Please configure at least one referral scheme mapping')
            return;
        }

        agencyProcess(params);
    }

    const markAsVerified = () => {
        setShowConfirmation(true);
        setActionType('markAsVerified');
        setConfirmationMessage(`Are you sure you want to mark as verified ?`);
    }

    const changeAgencyStatus = () => {
        setActionType(`${selectedInput.status === 1 ? "inactive" : "active"}`);
        setShowConfirmation(true)
        setConfirmationMessage(`Are you sure you want to mark ${selectedInput.agency_name} ${[AGENCY_STATUS['inactive'], AGENCY_STATUS['rejected']].includes(+selectedInput.status) ? "as active" : "as inactive"} ?`)
    }

    const activeTabHandler = (key: any) => { 
        setActiveTab(key);
    }

    useEffect(() => {
        if (agencyType && agencyAgentData?.length > 0) {
            const label = agencyAgentData.find(item => +item.value === +agencyType)?.label;
            if (label) setBasicDetailsName(label);
        }
    }, [agencyType, agencyAgentData]);
    

    // set Mapped name into dropdown
    const getSalesOfficerName = async () => {
        setLoading(true)
        let params = {slug : "sales_officer",type:2}
        const users: any = await getSalesOfficerList(params)
        if (users?.data?.length) {
            setSalesAgentOfficerName(users.data)
        }
        setLoading(false)
    }
    
    return (
        <>
            <div className="container-fluid">
                <FullPageLoader show={loading} />

                <div className="top-heading financer-lead-heding" style={{ background: "#fff", padding: "30px" }}>
                    <h2>{!agency_id ? "Add Agent" : `${selectedInput.agency_name} ${selectedInput.id ? `(ID: ${selectedInput.id})` : ""}`}</h2>

                    <div className='d-flex edit-approve-btn-top'>
                        { (activeTab !== "third") && ((agency_id) && (HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_agency_partner_management'], accessType: 'edit' }))) &&
                            <button className="btn-line" onClick={handleEdit} disabled={[AGENCY_DOC_STATUS['resubmit']].includes(+selectedInput.doc_status)}>
                                {
                                    !editForm ? <> <i className='ic-edit m-xs-r'></i> <span>Edit</span></> : <span>Cancel</span>
                                }
                            </button>

                        }

                        { (activeTab !== "third") && (agency_id && +selectedInput.source !== SOURCE_WEB) &&
                            <div className='m-sm-l d-flex'>
                                {
                                    ([AGENCY_DOC_STATUS['pending'], AGENCY_DOC_STATUS['resubmit'], AGENCY_DOC_STATUS['approved'], AGENCY_DOC_STATUS['rejected']].includes(+selectedInput.doc_status) && ![AGENCY_STATUS['active'], AGENCY_STATUS['inactive'], !AGENCY_STATUS['rejected']].includes(+selectedInput.status) && (HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_agency_partner_management'], accessType: 'edit' }))) ?
                                        <>
                                            <button className="btn-primary" onClick={() => { checkAgencyApprovedOrNot("approve") }} disabled={[AGENCY_DOC_STATUS['resubmit']].includes(+selectedInput.doc_status)}>
                                                Approve
                                            </button>
                                            {
                                                ![AGENCY_STATUS['rejected']].includes(+selectedInput.status) &&
                                                <button className="btn-line m-sm-l" onClick={() => { agencyProcess("reject") }} disabled={[AGENCY_DOC_STATUS['resubmit']].includes(+selectedInput.doc_status)}>
                                                    Reject
                                                </button>
                                            }
                                        </> : ''
                                }

                            </div>
                        }

                        {
                           (activeTab !== "third") && agency_id && (+selectedInput.status === AGENCY_STATUS['active'] && (HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_agency_partner_management'], accessType: 'edit' }))) &&
                            <div className='m-sm-l d-flex'>
                                <button className="btn-line" onClick={changeAgencyStatus}>
                                    Inactive
                                </button>
                            </div>


                        }

                        {
                           (activeTab !== "third") && agency_id && ([AGENCY_STATUS['inactive']].includes(+selectedInput.status) && (HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_agency_partner_management'], accessType: 'edit' }))) &&
                            <div className='m-sm-l d-flex'>
                                <button className="btn-line" onClick={changeAgencyStatus}>
                                    Active
                                </button>
                            </div>


                        }

                        {
                          (activeTab !== "third") &&   agency_id && <div className='m-sm-l d-flex'>
                                <button className="btn-line" onClick={() => { setViewTimeLine(true) }}>
                                    View History
                                </button>
                            </div>
                        }
                    </div>

                </div>

                <div className="agency-insurance-partner-management">

                    <Tab.Container id="left-tabs-example" defaultActiveKey={"first"}>

                        <Nav variant="pills" className="flex-column tab-line nav nav-pills"
                            onSelect={(k) => activeTabHandler(k)}
                        >
                            <div className="tab-list d-flex">

                                <Nav.Item>
                                    <Nav.Link eventKey="first">Basic Details</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">Insurance Partner Mapping</Nav.Link>
                                </Nav.Item>
                                {
                                    ACTIVE_INACTIVE_AGENCY?.includes(+selectedInput.status) && 
                                    <Nav.Item>
                                        <Nav.Link eventKey="third">Users Login</Nav.Link>
                                    </Nav.Item>
                                }                       


                            </div>
                        </Nav>


                        <Tab.Content>
                            <Tab.Pane eventKey="first">
                                <div className="p-lg agency-panel-form">
                                    <Tab.Container id="left-tabs-example" defaultActiveKey={defaultTab}>
                                        <div className="p-rel">
                                            <div className="role-management-top-sec">
                                                {!selectedInput.type && <h2>Channel Type</h2>}

                                                <div className="selected-chips p-lg-t">
                                                    {
                                                        !selectedInput.type &&
                                                        <Nav variant="pills" className="flex-column nav nav-pills">
                                                            <div className="tab-list d-flex m-lg-b">
                                                                {
                                                                    agencyAgentData?.map((item,index) => (
                                                                        <Nav.Item key={item.value}>
                                                                            <Nav.Link eventKey={`tab-${index}`} onClick={() => { addDataFor(item.label) }}>{item.label}</Nav.Link>
                                                                        </Nav.Item>
                                                                    ))
                                                                }
                                                            </div>
                                                        </Nav>
                                                    }

                                                </div>

                                            </div>
                                        </div>
                                    </Tab.Container>
                                    <div className=''>


                                        <div className="row agency-create-flow">
                                            <div className="col-md-12">
                                                <div className="Add-Financer-popup bankdetail-popup add-agency-form">
                                                    <div className="row">
                                                        <fieldset className="col-md-3 ">
                                                            <div className="material" title={selectedInput?.agency_name}>
                                                                <InputField
                                                                    inputProps={{
                                                                        id: "",
                                                                        name: "agency_name",
                                                                        className: "form-input",
                                                                        type: "text",
                                                                        value: selectedInput?.agency_name || '',
                                                                        maxLength: "",
                                                                        placeholder: " ",
                                                                        disabled: disableField,
                                                                    }}
                                                                    onChange={(e: any) => handleInputChange('agency_name', e)}
                                                                />
                                                                <label data-label={`Agent Name*`} className="form-label"></label>
                                                                {
                                                                    errors && errors.agency_name
                                                                        ?
                                                                        <span className="error-txt">{errors.agency_name}</span>
                                                                        :
                                                                        ''
                                                                }
                                                            </div>
                                                        </fieldset>

                                                        <fieldset className="col-md-3 ">
                                                            <div className="material" title={selectedInput?.email}>
                                                                <InputField
                                                                    inputProps={{
                                                                        id: "email",
                                                                        name: "email",
                                                                        className: "form-input",
                                                                        type: "text",
                                                                        value: selectedInput.email || '',
                                                                        maxLength: "",
                                                                        disabled: disableField,
                                                                        placeholder: " "
                                                                    }}
                                                                    onChange={(e: any) => handleInputChange('email', e)}
                                                                />

                                                                <label data-label="Email *" className="form-label"></label>
                                                                {
                                                                    errors && errors.email
                                                                        ?
                                                                        <span className="error-txt">{errors.email}</span>
                                                                        :
                                                                        ''
                                                                }
                                                            </div>
                                                        </fieldset>

                                                        <fieldset className="col-md-3 ">
                                                            <div className="material" title={selectedInput?.mobile}>
                                                                <InputField
                                                                    inputProps={{
                                                                        id: "mobile",
                                                                        name: "mobile",
                                                                        className: "form-input",
                                                                        type: "text",
                                                                        value: (selectedInput.mobile) ? selectedInput.mobile : '',
                                                                        maxLength: "10",
                                                                        disabled: disableField,
                                                                        placeholder: " "

                                                                    }}
                                                                    onChange={(e: any) => handleInputChange('mobile', e)}
                                                                />
                                                                <label data-label="Mobile *" className="form-label"></label>
                                                                {
                                                                    errors && errors.mobile
                                                                        ?
                                                                        <span className="error-txt">{errors.mobile}</span>
                                                                        :
                                                                        ''
                                                                }
                                                            </div>
                                                        </fieldset>

                                                        <fieldset className="col-md-3 ">
                                                            <div className="material" title={selectedInput?.tin_id_no}>
                                                                <InputField
                                                                    inputProps={{
                                                                        id: "tin_id_no",
                                                                        name: "tin_id_no",
                                                                        className: "form-input",
                                                                        type: "text",
                                                                        value: selectedInput.tin_id_no || '',
                                                                        maxLength: "",
                                                                        disabled: disableField,
                                                                        placeholder: " "
                                                                    }}
                                                                    onChange={(e: any) => handleInputChange('tin_id_no', e)}
                                                                />
                                                                <label data-label="TIN Number *" className="form-label"></label>
                                                                {
                                                                    errors && errors.tin_id_no
                                                                        ?
                                                                        <span className="error-txt">{errors.tin_id_no}</span>
                                                                        :
                                                                        ''
                                                                }
                                                            </div>
                                                        </fieldset>

                                                        <div className='form-select-bx col-md-3 partner-add-edit'>
                                                            <ReactSelect
                                                                //options={soList}
                                                                options = {salesAgentOfficerName} 
                                                                //value={soList?.find((option) => option.value === selectedInput?.agent_id)}
                                                                value={salesAgentOfficerName.find((option) => option.value === selectedInput?.agent_id)}
                                                                handleChange={(e: any, fieldKey: string) => handleSelectChange(fieldKey, e)}
                                                                placeholder="Sales Account Officer*"
                                                                fieldKey="agent_id"
                                                                isDisabled={disableField}
                                                                errorField={errors.agent_id}
                                                            />
                                                        </div>

                                                        {/* VAT Payout*/}
                                                         <div className='form-select-bx col-md-3 partner-add-edit'>
                                                            <ReactSelect
                                                                options={vatPayOut}
                                                                value={vatPayOut?.find((option) => option.value === (selectedInput?.vat_pay_out ?? 0) )} 
                                                                handleChange={(e: any, fieldKey: string) => handleSelectChange(fieldKey, e)}
                                                                placeholder="VAT Payout"
                                                                fieldKey="vat_pay_out"
                                                                isDisabled={disableField}
                                                            />
                                                        </div>
                                                      
                                                        {/* <div className='form-select-bx col-md-3 partner-add-edit'>
                                                            <ReactSelect
                                                                options={creditTerm}
                                                                value={creditTerm?.find((option) => option.value === selectedInput?.credit_terms)}
                                                                handleChange={(e: any, fieldKey: string) => handleSelectChange(fieldKey, e)}
                                                                placeholder="Credit Term*"
                                                                fieldKey="credit_terms"
                                                                isDisabled={disableField}
                                                                errorField={errors.credit_terms}
                                                            />
                                                        </div> */}

                                                        <div className='form-select-bx col-md-3 partner-add-edit'>
                                                            <fieldset className="single-select multiselect-dropDown">
                                                                <div className={(selectedInput['map_sales_agent_officer'] && selectedInput['map_sales_agent_officer'].length) ? "active-label material animation-effect" : "material animation-effect "}>
                                                                    <MultiSelect
                                                                       // options={mappedSalesOfficer}
                                                                        options = {salesAgentOfficerName} 
                                                                       isSelectAll={true}
                                                                        // value={
                                                                        //     mappedSalesOfficer?.filter((option: any) =>
                                                                        //         selectedInput?.map_sales_agent_officer?.includes(option.value)
                                                                        //     ) || []
                                                                        // }
                                                                        value={
                                                                            salesAgentOfficerName.filter((option: any) =>
                                                                                selectedInput?.map_sales_agent_officer?.includes(option.value)
                                                                            ) || []
                                                                        }
                                                                        // value={soList?.find((option) => option.value === selectedInput?.agent_id)}
                                                                        onChange={(e: any, fieldKey: string) => handleSelectChange("map_sales_agent_officer", e, true)}
                                                                        placeholder={""}
                                                                        isClearable={false}
                                                                    />
                                                                    <label data-label={"Mapped Sales Agent Officer *"} className="form-label"></label>
                                                                    {errors?.map_sales_agent_officer ? <span className="error-txt">{errors?.map_sales_agent_officer}</span> : null}
                                                                </div>
                                                            </fieldset>
                                                        </div>

                                                    </div>
                                                    <div className='row p-lg-b'>
                                                        {previewImages?.length > 0 && previewImages.map((image: any, index: any) => (

                                                            <div className="col-md-2" key={`doc-${index}`}>

                                                                <div key={index} className="image-container-agency">
                                                                    {
                                                                        image?.type?.indexOf("pdf") !== -1
                                                                            ?
                                                                            <i className={`ic-${image?.type}-file icons-normal t-accent`} onClick={() => showImagePopup(index)}></i>
                                                                            :
                                                                            <img src={image.url} alt={`preview-${index}`} className="upload-icn" onClick={() => showImagePopup(index)} />

                                                                    }

                                                                    {
                                                                        editForm && (selectedInput?.documents?.length > 1 || !image.id) &&
                                                                        <div className="close-icn" onClick={() => handleImageDelete({ ...image, id: (image.id || index), type: (!image.id ? "new" : "old") })}>
                                                                            <i className="ic-clearclose" style={{ position: "absolute", top: 0, right: 0 }}></i>

                                                                        </div>
                                                                    }
                                                                    {
                                                                        (+selectedInput?.doc_status === AGENCY_DOC_STATUS['approved'] && image.id) &&
                                                                        <span className="image-status">Approved</span>
                                                                    }
                                                                    {
                                                                        +selectedInput?.doc_status === AGENCY_DOC_STATUS['resubmit'] && image.id &&
                                                                        <span className="image-requested">Requested</span>
                                                                    }
                                                                    {
                                                                        +selectedInput?.doc_status === AGENCY_DOC_STATUS['rejected'] && image.id &&
                                                                        <span className="image-requested">Rejected</span>
                                                                    }
                                                                </div>

                                                            </div>
                                                        ))
                                                        }

                                                        {
                                                            previewImages?.length < MAX_FILE_UPLOAD &&
                                                            <div className="img-bx-select-opt col-md-2 add-basic-doc">
                                                                <div className="image-bx more-file-upload add-insurance-partner">


                                                                    <div className="document-image-container ">
                                                                        <div role="presentation" className="add-new-image upload-input-bx">
                                                                            {
                                                                                <input type="file" className="upload-image-input" name="documents[]" onChange={(e: any) => handleFileInputChange(e)} multiple disabled={disableField} style={{ zIndex: 0 }}/>
                                                                            }
                                                                            <i className="ic-add"> </i>
                                                                            <span>Add Document</span>
                                                                        </div>
                                                                    </div>

                                                                    {
                                                                        errors && errors.images
                                                                            ?
                                                                            <span className="error-txt error-left">{errors.images}</span>
                                                                            :
                                                                            ''
                                                                    }
                                                                </div>
                                                            </div>
                                                        }

                                                        {
                                                            editForm && selectedInput?.documents?.length > 0 && +selectedInput.source === 1 && ![AGENCY_DOC_STATUS['approved'], AGENCY_DOC_STATUS['resubmit']].includes(+selectedInput.doc_status) &&
                                                            <div className='col-md-12 p-sm-t p-sm-b resubmit-btn'>
                                                                <button className="btn-line" onClick={() => { handleResubmitDoc('resubmit') }}>
                                                                    Resubmit
                                                                </button>

                                                                <button className="btn-line m-sm-l" onClick={markAsVerified}>
                                                                    mark as verified
                                                                </button>
                                                            </div>

                                                        }

                                                    </div>

                                                    <div className='row'>
                                                        <div className='form-select-bx col-md-3 partner-add-edit'>
                                                            <ReactSelect options={agencyBanksLists || []} value={agencyBanksLists.find((option: any) => +option.value === +selectedInput.bank_name)} handleChange={(e: any) => handleChange('bank_name', e)} placeholder="Bank Name *" fieldKey="bank_name" errorField={errors?.bank_name ? errors?.bank_name : ''} isDisabled={disableField} />
                                                        </div>

                                                        <fieldset className="col-md-3 ">
                                                            <div className="material" title={selectedInput?.branch_name}>
                                                                <InputField
                                                                    inputProps={{
                                                                        id: "branch_name",
                                                                        name: "branch_name",
                                                                        className: "form-input",
                                                                        type: "text",
                                                                        value: selectedInput.branch_name || '',
                                                                        maxLength: "",
                                                                        disabled: disableField,
                                                                        placeholder: " "
                                                                    }}
                                                                    onChange={(e: any) => handleInputChange('branch_name', e)}
                                                                />
                                                                <label data-label="Branch Name" className="form-label"></label>

                                                            </div>
                                                        </fieldset>


                                                        <fieldset className="col-md-3 ">
                                                            <div className="material" title={selectedInput?.account_no}>
                                                                <InputField
                                                                    inputProps={{
                                                                        id: "account_no",
                                                                        name: "account_no",
                                                                        className: "form-input",
                                                                        type: "text",
                                                                        value: selectedInput.account_no || '',
                                                                        maxLength: "",
                                                                        disabled: disableField,
                                                                        placeholder: " "
                                                                    }}
                                                                    onChange={(e: any) => handleInputChange('account_no', e)}
                                                                />
                                                                <label data-label="Account Number *" className="form-label"></label>
                                                                {
                                                                    errors && errors.account_no
                                                                        ?
                                                                        <span className="error-txt">{errors.account_no}</span>
                                                                        :
                                                                        ''
                                                                }
                                                            </div>
                                                        </fieldset>

                                                        <fieldset className="col-md-3 ">
                                                            <div className="material" title={selectedInput?.account_name}>
                                                                <InputField
                                                                    inputProps={{
                                                                        id: "account_name",
                                                                        name: "account_name",
                                                                        className: "form-input",
                                                                        type: "text",
                                                                        value: selectedInput.account_name || '',
                                                                        maxLength: "",
                                                                        disabled: disableField,
                                                                        placeholder: " "
                                                                    }}
                                                                    onChange={(e: any) => handleInputChange('account_name', e)}
                                                                />
                                                                <label data-label="Account Name *" className="form-label"></label>
                                                                {
                                                                    errors && errors.account_name
                                                                        ?
                                                                        <span className="error-txt">{errors.account_name}</span>
                                                                        :
                                                                        ''
                                                                }
                                                            </div>
                                                        </fieldset>
                                                        <fieldset className="form-filed col-md-3  m-b-1">
                                                            <div className="material">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        id="is_doc_required"
                                                                        name="is_doc_required"
                                                                        type="checkbox"
                                                                        checked={+selectedInput?.is_doc_required === 1}
                                                                        onChange={(e: any) => handleInputChange('is_doc_required',e)}
                                                                        className="custom-control-input"
                                                                        placeholder=" "
                                                                        disabled={disableField}
                                                                    />

                                                                    <label className="custom-control-label">Enable Bulk Upload without docs</label>
                                                                </div>
                                                            </div>
                                                        </fieldset>
                                                    </div >

                                                </div>
                                            </div>

                                            {
                                                resubmitDocPopup && <DocResubmitModal showModal={resubmitDocPopup} agency_id={agency_id} closeResubmitModal={() => setResubmitDocPopup(false)} handleType={handleType} triggerApi={() => { setTrigger(trigger + 1); setResubmitDocPopup(false) }} />
                                            }

                                            {
                                                imageSlider && <ImageSlider showModal={imageSlider} sliderImages={previewImages} agency_id={agency_id} closeResubmitModal={() => setImageSlider(false)} activeImageIndex={activeImageIndex} selectedAgency={selectedInput} editForm={editForm} handleResubmitDocTrigger={handleResubmitDoc} markAsVerifiedTrigger={markAsVerified} />
                                            }

                                        </div>
                                    </div>
                                    <div className="btn-bottom t-center">
                                        {

                                            HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_agency_partner_management'], accessType: 'edit' }) &&
                                            <button type='submit' className="btn-primary" onClick={handleSubmit} disabled={disableField}>
                                                Submit Details
                                            </button>
                                        }
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second">
                                <AgencyPartnerMapping handleEdit={handleEdit} disableField={disableField} agency_id={agency_id} partnerMapping={selectedInput?.partnerMapping || []} updatePartnerCount={updatePartnerCount} creditTerm ={creditTerm} />
                                
                            </Tab.Pane>

                            <Tab.Pane eventKey="third">
                                <AgencyUserListTable agency_id ={agency_id} setTriggerAgencyList= {setTriggerAgencyList} triggerAgencyList = {triggerAgencyList}/>              
                            </Tab.Pane>

                        </Tab.Content>

                    </Tab.Container>

                </div>

            </div>

            {showConfirmation === false ? ("") : (
                <ConfirmPopUp
                    confirmNo={confirmNo}
                    confirmYes={confirmYes}
                    message={confirmationMessage} />
            )}

            {agency_id && <AgencyCommentModal viewTimeLine={viewTimeLine} agency_id={agency_id} handleViewTimeLine={() => setViewTimeLine(false)} />}

        </>

    )
}
